import React from 'react';
import { motion } from 'framer-motion';

const lookbookItems = [
  {
    img: "https://static.prod-images.emergentagent.com/jobs/0aefe824-dd3a-42e7-88bf-f336a3227281/images/f37bf6889187d08e252da4d673f730823bb527796f1b7148810e0e42392e73b9.png",
    caption: "Nayi pehchaan, purani riwayat",
    tag: "Everyday Elegance",
    tall: true,
  },
  {
    img: "https://images.pexels.com/photos/28512776/pexels-photo-28512776.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Simple hai, par kuch alag baat hai",
    tag: "Classic White",
    tall: false,
  },
  {
    img: "https://images.pexels.com/photos/28512773/pexels-photo-28512773.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Apni roots se connected, apne style mein confident",
    tag: "Modern Heritage",
    tall: false,
  },
  {
    img: "https://images.unsplash.com/photo-1590242157838-a7dd8990b1c1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
    caption: "Har din ek celebration hai",
    tag: "Everyday Luxury",
    tall: true,
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } }
};

export default function LookbookSection() {
  return (
    <section id="lookbook" data-testid="lookbook-gallery" className="py-24 md:py-32 bg-[#E8DED1]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <motion.div
          variants={{ hidden: { opacity: 0 }, visible: { opacity: 1, transition: { staggerChildren: 0.12 } } }}
          initial="hidden" whileInView="visible" viewport={{ once: true }}
          className="text-center mb-14 md:mb-18"
        >
          <motion.span variants={fadeUp} className="inline-block text-xs md:text-sm font-sans uppercase tracking-[0.25em] text-[#C9A84C] font-medium mb-4">
            Nayi Nazar, Purani Riwayat
          </motion.span>
          <motion.h2 variants={fadeUp} className="font-serif font-light text-[#2D4A2D] text-4xl md:text-5xl leading-tight tracking-tight mb-4">
            The Lookbook
          </motion.h2>
          <motion.p variants={fadeUp} className="font-sans font-light text-[#5C6B5C] text-base max-w-md mx-auto">
            Ek jhalkii hamaare pieces ki — jo sirf kapde nahi, ek feeling hai.
          </motion.p>
        </motion.div>

        {/* Masonry-style Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {lookbookItems.map((item, i) => (
            <motion.div
              key={item.tag}
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-50px" }}
              transition={{ delay: i * 0.1 }}
              className={`relative overflow-hidden group cursor-pointer ${item.tall ? 'row-span-2' : 'row-span-1'}`}
              style={{ aspectRatio: item.tall ? undefined : '3/4', minHeight: item.tall ? '500px' : '240px' }}
            >
              <img
                src={item.img}
                alt={item.caption}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              {/* Hover overlay */}
              <div className="absolute inset-0 bg-[#2D4A2D]/0 group-hover:bg-[#2D4A2D]/60 transition-all duration-500 flex flex-col justify-end p-5">
                <div className="translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-400">
                  <span className="text-xs font-sans uppercase tracking-[0.2em] text-[#C9A84C] mb-2 block">
                    {item.tag}
                  </span>
                  <p className="font-serif italic text-[#F5F0E8] text-lg leading-tight">
                    {item.caption}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}
          className="text-center mt-12"
        >
          <p className="font-sans font-light text-[#5C6B5C] text-sm mb-6">
            Designs update kar'te rehte hain. WhatsApp community join karo — first look milega!
          </p>
          <a
            href="https://chat.whatsapp.com/HxBfbxuBabo9BVEYJPbj3c?mode=gi_t"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="lookbook-wa-cta"
            className="inline-flex items-center gap-2.5 bg-[#2D4A2D] text-[#F5F0E8] px-8 py-4 font-sans font-medium text-sm tracking-wide transition-all duration-300 hover:bg-[#1A2A1A] hover:text-[#C9A84C]"
          >
            Get First Access
          </a>
        </motion.div>
      </div>
    </section>
  );
}
